var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34183 4.375C3.65332 4.375 2.68949 6.30267 3.70259 7.65348C4.13499 8.23001 4.36873 8.93123 4.36873 9.6519V15C4.36873 17.1861 6.14094 18.9583 8.32707 18.9583H11.6604C13.8465 18.9583 15.6187 17.1861 15.6187 15V9.6519C15.6187 8.93123 15.8525 8.23001 16.2849 7.65348C17.298 6.30267 16.3341 4.375 14.6456 4.375H5.34183ZM11.6641 8.54167C12.0092 8.54167 12.2891 8.82149 12.2891 9.16667V14.1667C12.2891 14.5118 12.0092 14.7917 11.6641 14.7917C11.3189 14.7917 11.0391 14.5118 11.0391 14.1667V9.16667C11.0391 8.82149 11.3189 8.54167 11.6641 8.54167ZM8.95573 9.16667C8.95573 8.82149 8.67591 8.54167 8.33073 8.54167C7.98555 8.54167 7.70573 8.82149 7.70573 9.16667V14.1667C7.70573 14.5118 7.98555 14.7917 8.33073 14.7917C8.67591 14.7917 8.95573 14.5118 8.95573 14.1667V9.16667Z",
    fill: "#ED1C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 5L12.9532 3.86754C12.681 3.05086 11.9167 2.5 11.0559 2.5H8.93891C8.07805 2.5 7.31378 3.05086 7.04155 3.86754L6.66406 5",
    stroke: "#ED1C00",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/trash-filled.70b9bab960909a645553e13cb91a271d.svg";
export { ForwardRef as ReactComponent };